module.exports = __webpack_public_path__ + "front/img/5.dce031e0.jpg";